<template>
  <div
    :class="
      navigation || culturePop
        ? 'popup'
        : '' || startProjectPop || recruitPop
        ? 'popup black'
        : '' || awardsPop
        ? 'black-gra'
        : ''
    "
    class="container viewPage titleistAView"
  >
    <header-area />

    <div class="worksView">
      <div class="contsBox">
        <div class="viewInCon">
          <div class="workTopTitle">
            <div class="workSlogan web">Online for <br />Offline</div>
            <div class="workSlogan mobile">Online for <br />Offline</div>
            <div class="workTopDay">
              <p>타이틀리스트 어패럴 웹사이트 개편</p>
              <ul>
                <li>PC / Mobile web</li>
                <li>2021.02.16</li>
              </ul>
            </div>
            <div class="workTopSns">
              <a href="https://titleistapparel.co.kr/" target="_blank" class="siteAddr"
                >https://titleistapparel.co.kr/</a
              >
              <ul>
                <li>
                  <social-sharing
                    url="https://www.pulip.com/sns/titleist-a"
                    title="온라인에서의 경험을 오프라인으로 잇다."
                    hashtags="플립커뮤니케이션즈,타이틀리스트"
                    twitter-user="플립커뮤니케이션즈"
                    inline-template
                  >
                    <network network="facebook">
                      <a href="javascript:;" class="wFacebook">
                        <img src="@/assets/images/@sns_fb_w.png" alt="" />
                      </a>
                    </network>
                  </social-sharing>
                </li>
                <li>
                  <social-sharing
                    url="https://www.pulip.com/sns/titleist-a"
                    title="온라인에서의 경험을 오프라인으로 잇다."
                    hashtags="플립커뮤니케이션즈,타이틀리스트"
                    twitter-user="플립커뮤니케이션즈"
                    inline-template
                  >
                    <network network="twitter">
                      <a href="javascript:;" class="wTweeter">
                        <img src="@/assets/images/@sns_tw_w.png" alt="" />
                      </a>
                    </network>
                  </social-sharing>
                </li>
                <li>
                  <a href="javascript:;" @click.prevent="doCopy" class="wChain">
                    <img src="@/assets/images/@web_link_w.png" alt="" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="workVisual">
        <div class="workImg">
          <span class="workMoveTxt"
            ><marquee-text :duration="16">&nbsp;Online for Offline</marquee-text></span
          >
          <img
            src="@/assets/images/works_view/titleist_a/titleist_a_visual.jpg"
            alt=""
            class="web"
          />
          <img
            src="@/assets/images/works_view/titleist_a/titleist_a_visual_m.jpg"
            alt=""
            class="mobile"
          />
        </div>
      </div>
      <div class="bgColorTop">
        <div class="contsBox">
          <p>
            국내 골프 의류 시장 1위 브랜드인 타이틀리스트 어패럴은 오프라인 스토어에서만 제품을
            판매하고 있습니다. 일반적인 골프 의류 브랜드와 달리 오직 오프라인에서만 구매가
            이루어지기에 타이틀리스트 어패럴 디지털 플랫폼의 역할과 전략은 명료했습니다. 제품 구매를
            위해 매장으로 방문을 유도하거나, 당장 구매하지 않더라도 골프와 관련된 상황에서
            타이틀리스트 어패럴을 떠올릴 수 있도록 오프라인을 위한 온라인 플랫폼을 기획했습니다.
          </p>
        </div>
      </div>
    </div>

    <div class="wideConts">
      <div class="worksView">
        <div class="titleistAStart">
          <div
            class="titleistGoal"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="salesExperience">
              <span><i>experience</i>입체적인 경험 제공</span>
              <span><i>sales</i>스토어 방문 유도</span>
            </div>
            <p class="goal">Online for Offline</p>
          </div>
          <div
            class="titleistLogo"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <img src="@/assets/images/works_view/titleist_a/titleist_logo.png" alt="" />
            <p class="web">
              웹사이트 방문 고객에게 입체적인 경험을 제공하여 매장으로 유도하거나 <br />당장
              구매하지 않더라도 골프와 관련된 상황에서 타이틀리스트 어패럴을 연상
            </p>
            <p class="mobile">
              웹사이트 방문 고객에게 입체적인 경험을 <br />제공하여 매장으로 유도하거나 <br />당장
              구매하지 않더라도 골프와 관련된 <br />상황에서 타이틀리스트 어패럴을 연상
            </p>
          </div>
        </div>
      </div>
      <div class="titleistAVideo">
        <video
          playsinline
          muted="muted"
          autoplay="autoplay"
          preload="auto"
          loop="loop"
          poster="@/assets/images/works_view/titleist_a/titleist_video_bg1.jpg"
        >
          <source src="@/assets/images/works_view/titleist_a/taVideo1.mp4" type="video/mp4" />
        </video>
      </div>
      <div class="titleistABox">
        <div class="conceptBox">
          <span class="concept">#<br />Features</span>
          <strong class="titleB">Search keyword<br />linkage</strong>
          <div class="txtBox">
            <strong class="title">검색 키워드 연동 상품 노출</strong>
            <p class="web">
              사용자가 타이틀리스트 어패럴 사이트를 방문하기 위해 검색한 <br />키워드와 연관된 상품
              카테고리가 노출되며 사용자 중심의 콘텐츠 제공이 가능하도록 구현했습니다.
            </p>
            <p class="mobile">
              사용자가 타이틀리스트 어패럴 사이트를 방문하기 위해 검색한 키워드와 연관된 상품
              카테고리가 노출되며 사용자 중심의 콘텐츠 제공이 가능하도록 구현했습니다.
            </p>
          </div>
        </div>
        <div class="arrowArea">
          <img src="@/assets/images/works_view/titleist_a/titleist_scroll2.png" alt="" />
        </div>
      </div>
      <div class="titleistAVideo">
        <video
          playsinline
          muted="muted"
          autoplay="autoplay"
          preload="auto"
          loop="loop"
          poster="@/assets/images/works_view/titleist_a/titleist_video_bg2.jpg"
        >
          <source src="@/assets/images/works_view/titleist_a/taVideo2.mp4" type="video/mp4" />
        </video>
      </div>
      <div class="titleistAMain">
        <div class="mainGrid menType">
          <div class="sec1Slider swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <img src="@/assets/images/works_view/titleist_a/main_product_men1.png" alt="" />
              </div>
              <div class="swiper-slide">
                <img src="@/assets/images/works_view/titleist_a/main_product_men2.jpg" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="mainGrid womenType">
          <div class="sec2Slider swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <img src="@/assets/images/works_view/titleist_a/main_product_women1.png" alt="" />
              </div>
              <div class="swiper-slide">
                <img src="@/assets/images/works_view/titleist_a/main_product_women2.jpg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="titleistABox">
        <div class="conceptBox">
          <span class="concept">#<br />Features</span>
          <strong class="titleB">Connected <br />information</strong>
          <div class="txtBox">
            <strong class="title">입체적인 제품정보</strong>
            <p>
              제품을 다양한 각도에서 상세하게 살펴볼 수 있는 키 아이템들의 동영상 콘텐츠, 마음에
              드는 상품으로 직접 스타일을 연출해 볼 수 있는 Self-Styling과 매장별 아이템 재고 현황
              조회, 신제품 매장 입고 알림신청 기능 등 풍부한 제품 탐색 경험과 매장으로 연결을 위한
              편리한 기능들을 새롭게 구현했습니다.
            </p>
          </div>
        </div>
        <div class="arrowArea">
          <img src="@/assets/images/works_view/titleist_a/titleist_scroll2.png" alt="" />
        </div>
      </div>
      <div
        class="titleistAPrd"
        v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
      >
        <div class="prdScroll">
          <div class="rolling">
            <div>
              <img src="@/assets/images/works_view/titleist_a/product_view_scroll.jpg" alt="" />
            </div>
          </div>
        </div>
        <div class="prdBox type1">
          <div>
            <video
              playsinline
              muted="muted"
              autoplay="autoplay"
              preload="auto"
              loop="loop"
              poster="@/assets/images/works_view/titleist_a/product_view_img1.png"
            >
              <source src="@/assets/images/works_view/titleist_a/taVideo3.mp4" type="video/mp4" />
            </video>
          </div>
        </div>
        <div class="prdBox type2">
          <div>
            <img src="@/assets/images/works_view/titleist_a/product_view_img2.png" alt="" />
          </div>
        </div>
        <div class="prdBox type3">
          <div class="sec3Slider swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <img src="@/assets/images/works_view/titleist_a/list_thumbnail_01.jpg" alt="" />
              </div>
              <div class="swiper-slide">
                <img src="@/assets/images/works_view/titleist_a/list_thumbnail_02.jpg" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="prdBox type4">
          <div>
            <img src="@/assets/images/works_view/titleist_a/product_view_img3.jpg" alt="" />
          </div>
        </div>
        <div class="prdBox type5">
          <div class="sec4Slider swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <img src="@/assets/images/works_view/titleist_a/list_slide_01.jpg" alt="" />
              </div>
              <div class="swiper-slide">
                <img src="@/assets/images/works_view/titleist_a/list_slide_02.jpg" alt="" />
              </div>
              <div class="swiper-slide">
                <img src="@/assets/images/works_view/titleist_a/list_slide_03.jpg" alt="" />
              </div>
              <div class="swiper-slide">
                <img src="@/assets/images/works_view/titleist_a/list_slide_04.jpg" alt="" />
              </div>
              <div class="swiper-slide">
                <img src="@/assets/images/works_view/titleist_a/list_slide_05.jpg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="titleistABox type2">
        <div class="boxCnt">
          <div class="conceptBox">
            <span class="concept">#<br />Features</span>
            <strong class="titleB web">Digital archive</strong>
            <strong class="titleB mobile">Digital<br />archive</strong>
            <div class="txtBox">
              <strong class="title">lookbook / media library</strong>
              <p>
                PDF 파일로 제공하던 카탈로그를 디지털 콘텐츠로 제작하였으며, 지난 시즌 카탈로그 및
                광고 영상 등을 한곳에서 확인할 수 있는 미디어 라이브러리를 만들어 콘텐츠 아카이브를
                구성했습니다.
              </p>
            </div>
          </div>
          <div class="arrowArea">
            <img src="@/assets/images/works_view/titleist_a/titleist_scroll.png" alt="" />
          </div>
        </div>
        <div class="digitalLook">
          <div
            class="digitalLookPc"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="rBox">
              <div>
                <img src="@/assets/images/works_view/titleist_a/lookbook_pc_main.jpg" alt="" />
              </div>
            </div>
          </div>
          <div
            class="digitalLookMo"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="rBox">
              <div>
                <img src="@/assets/images/works_view/titleist_a/lookbook_mw_main.jpg" alt="" />
              </div>
            </div>
          </div>
          <div class="mediaLiabary">
            <div class="rBox">
              <div>
                <img src="@/assets/images/works_view/titleist_a/media_liabary_main.jpg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="titleistABox">
        <div class="conceptBox">
          <span class="concept">#<br />Features</span>
          <strong class="titleB">Self-<br />styling</strong>
          <div class="txtBox mt0">
            <strong class="title">나만의 골프웨어 스타일을 만들어보세요.</strong>
            <p>
              마음에 드는 아이템들은 My Pick 메뉴에 한데 모아 머리부터 발끝까지 내 마음대로
              스타일링을 해보고 완성된 스타일링은 저장하여 공유할 수 있습니다. 스타일링한 상품을
              스토어에서 직접 픽업하는 서비스로도 확장이 가능합니다.
            </p>
          </div>
        </div>
        <div class="arrowArea">
          <img src="@/assets/images/works_view/titleist_a/titleist_scroll2.png" alt="" />
        </div>
      </div>
      <div class="titleistAStyle">
        <div class="styleVideo">
          <div class="video">
            <video
              playsinline
              muted="muted"
              autoplay="autoplay"
              preload="auto"
              loop="loop"
              poster="@/assets/images/works_view/titleist_a/product_view_img1.png"
            >
              <source src="@/assets/images/works_view/titleist_a/taVideo4.mp4" type="video/mp4" />
            </video>
          </div>
        </div>
        <div
          class="prdBox type1"
          v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
        >
          <div>
            <img src="@/assets/images/works_view/titleist_a/self_styling_mw_01.jpg" alt="" />
          </div>
        </div>
        <div
          class="prdBox type2"
          v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
        >
          <div>
            <img src="@/assets/images/works_view/titleist_a/self_styling_mw_02.jpg" alt="" />
          </div>
        </div>
        <div
          class="prdBox type3"
          v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
        >
          <div>
            <img src="@/assets/images/works_view/titleist_a/self_styling_mw_03.jpg" alt="" />
          </div>
        </div>
      </div>
      <div class="titleistABox type3">
        <div class="boxCnt">
          <div class="conceptBox">
            <span class="concept">#<br />Result</span>
            <strong class="titleB">Promise of <br />Performance</strong>
            <div class="txtBox">
              <strong class="title">차별화된 디지털 경험과 다양한 고객 서비스 제공</strong>
              <p>
                제품을 더욱 자세하게 볼 수 있는 360도 동영상, 업계 최초의 My pick & Self-Styling
                기능, 매장별 아이템 재고 현황 및 신제품 매장입고 알림 신청 등 사용자 편의성을
                최우선으로 한 개편을 통해 골퍼들이 원하는 디지털 서비스에 한걸음 더 다가갈 수 있게
                되었습니다.
              </p>
            </div>
          </div>
          <div class="arrowArea">
            <img src="@/assets/images/works_view/titleist_a/titleist_scroll2.png" alt="" />
          </div>
          <div class="newsCnt">
            <p>
              타이틀리스트 어패럴과 풋조이를 판매하는 <br />아쿠쉬네트코리아는 지난 상반기 국내에서
              <br />약 2,074억원 매출을 올렸다. <br />전년 동기 1,374억원에서 50% 성장한 수치다.
            </p>
            <span class="date">매일경제 2021년 10월 22일</span>
          </div>
          <div
            class="phoneBox"
            v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
          >
            <div class="phoneTalk">
              <div>
                <img src="@/assets/images/works_view/titleist_a/mw_main_kv.jpg" alt="" />
              </div>
            </div>
            <span class="talkBox type1"
              >입고 시기를 전화로 물어보고 때를 놓쳐 못 사곤 했는데 입고 알림이나 재고현 황을
              확인하고 헛걸음할 일이 없어 너무 좋습니다.</span
            >
            <span class="talkBox type2"
              >맘에 드는 색상 및 디자인을 배치하고 저장해 두니 위시리스트가 되네요. 와이프한테
              이렇게 사달라고 공유할 수 있어좋습니다.</span
            >
            <span class="talkBox type3"
              >제품을 착용한 모델의 360도 모션을 보여주는 방식이 구매선택에 많은 도움이
              됩니다.</span
            >
          </div>
        </div>
      </div>
      <div class="titleistAEnd">
        <div class="contsBox">
          <div class="endTitle">A successful digital transformation partner</div>
          <p>
            빠르게 변화하는 4차 산업혁명의 시대 기업의 디지털 트랜스포메이션은 기업의 생존을 좌우 할
            수 있는 전략이며, 선택이 아닌 필수입니다.
            <br />플립커뮤니케이션즈는 성공적인 디지털 트랜스포메이션 전략과 수행 경험을 제공합니다.
          </p>
          <a href="https://www.pulip.com/contact" target="_blank"
            >디지털 트랜스포메이션 더 알아보기</a
          >
        </div>
      </div>
    </div>

    <div class="worksView">
      <div class="contsBox">
        <div class="backToList">
          <router-link :to="{ name: 'works' }" class="backBtn">
            <img src="@/assets/images/@ico_back_x2.jpg" alt="" />
            <span>Back to list</span>
          </router-link>
        </div>
      </div>

      <router-link v-if="true" :to="{ name: 'works-TitleistM' }" class="longEnd vType">
        <div class="viewType">
          <span>next</span>
          <strong class="web">타이틀리스트 인터랙티브 채널 마케팅 대행</strong>
          <strong class="mobile"
            >타이틀리스트 <br />인터랙티브 채널<br />
            마케팅 대행</strong
          >
        </div>

        <div class="engBg titleistMEndBg">
          <span />
        </div>
      </router-link>
    </div>

    <footer-area />
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import Lottie from "vue-lottie";
import HeaderArea from "@/components/Header";
import FooterArea from "@/components/Footer";
import common from "@/shared/mixin/common.js";
import MarqueeText from "vue-marquee-text-component";
import VueKinesis from "vue-kinesis";
import { TweenLite } from "gsap/all";
Vue.use(VueKinesis);

export default {
  mixins: [common],
  name: "Main",
  /* head: {
    title: {
      inner: '타이틀리스트 어패럴 웹사이트 개편'
    }
  }, */
  head: {
    title: function() {
      return {
        inner: this.meta.title
      };
    },
    meta: function() {
      return [
        {
          name: "description",
          content: this.meta.desc
        },
        {
          name: "keywords",
          content: this.meta.keywords
        },
        // Open Graph
        { property: "og:title", content: this.meta.title },
        { property: "og:description", content: this.meta.desc },
        { property: "og:type", content: "website" },
        { property: "og:url", content: this.meta.url },
        { property: "og:image", content: this.meta.img },

        // Additional OG tags
        { property: "og:site_name", content: this.meta.siteName }
      ];
    }
  },
  components: {
    HeaderArea,
    FooterArea,
    MarqueeText,
    Lottie
  },
  data() {
    return {
      meta: {
        siteName: "타이틀리스트 어패럴 홈페이지 | 플립커뮤니케이션즈",
        title: "타이틀리스트 어패럴 홈페이지",
        desc:
          "타이틀리스트 어패럴 웹사이트 개편을 통해 입체적인 제품 정보 제공, Self Styling 서비스, 디지털 아카이브 등 차별화된 디지털 경험을 제공함으로써 오프라인 매장 방문을 유도합니다. 고객 편의성을 위한 다양한 디지털 서비스를 제공하는 성공적인 온라인을 통한 오프라인 전략의 사례입니다.",
        keywords:
          "타이틀리스트 어패럴, 골프 의류, 온라인 플랫폼, 경험 제공, 스토어 방문 유도, 제품 구매, 매장 방문, 검색 키워드 연동, 상품 노출, 입체적인 제품정보, 동영상 콘텐츠, Self-Styling, 디지털 콘텐츠, 아카이브 구성, 사용자 편의성",
        url: "https://www.pulip.com/works/TitleistA",
        img: "https://www.pulip.com/pulip-logo.jpg"
      },
      W: 0,
      icoInter: null,
      icoVal: 0,
      kiwoomBgOpt01: { animationData: kiwoombg01, loop: true, autoplay: true }
    };
  },
  computed: {
    ...mapState("common", {
      startProjectPop: state => state.startProjectPop,
      recruitPop: state => state.recruitPop,
      awardsPop: state => state.awardsPop,
      culturePop: state => state.culturePop,
      navigation: state => state.navigation
    })
  },
  methods: {
    doCopy() {
      this.$copyText("https://www.pulip.com/sns/TitleistM").then(
        function(e) {
          alert("복사되었습니다.");
          console.log(e);
        },
        function(e) {
          console.log(e);
        }
      );
    },
    handleResize() {
      this.W = window.innerWidth;
      this.H = window.innerHeight;
    },
    visibilityChanged(isVisible, entry) {
      // this.isVisible = isVisible
      console.log(entry);
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    this.sec1Slider.destroy();
    this.sec2Slider.destroy();
    this.sec3Slider.destroy();
    this.sec4Slider.destroy();
    window.removeEventListener("resize", this.handleResize);
    clearInterval(this.icoInter);
  },
  mounted() {
    this.sec1Slider = new window.Swiper(".sec1Slider.swiper-container", {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      direction: "vertical",
      effect: "fade",
      slidesPerView: 1,
      speed: 1200,
      autoplay: {
        delay: 1500,
        disableOnInteraction: false
      }
    });
    this.sec2Slider = new window.Swiper(".sec2Slider.swiper-container", {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      direction: "vertical",
      slidesPerView: 1,
      effect: "fade",
      speed: 1000,
      autoplay: {
        delay: 1000,
        disableOnInteraction: false
      }
    });
    this.sec3Slider = new window.Swiper(".sec3Slider.swiper-container", {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      slidesPerView: 1,
      speed: 1300,
      loop: true,
      autoplay: {
        delay: 1000,
        disableOnInteraction: false
      }
    });
    this.sec4Slider = new window.Swiper(".sec4Slider.swiper-container", {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      slidesPerView: 1,
      speed: 1300,
      loop: true,
      autoplay: {
        delay: 1000,
        disableOnInteraction: false
      }
    });
  }
};
</script>
